module.exports = __webpack_public_path__ + "static/media/localfnfFacebook-1200x630.7062439e.jpg";